import { render, staticRenderFns } from "./WinePage.vue?vue&type=template&id=6ae5d686&scoped=true"
import script from "./WinePage.vue?vue&type=script&lang=js"
export * from "./WinePage.vue?vue&type=script&lang=js"
import style0 from "./WinePage.vue?vue&type=style&index=0&id=6ae5d686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae5d686",
  null
  
)

export default component.exports